import { Formio } from 'angular-formio';
import { environment } from 'src/environments/environment';

const Base = (Formio as any).Components.components.component;
const Components = (Formio as any).Components;

export class Upload extends Base {

  // Valores do formbuild do componente
  private component;
  // opções do form render
  private options;
  // objeto com o valor do componente
  private data;

  private editor;

  private inputs = [];

  private totalSize = 0;
  private limitSize:number = this.convertMBToByte(environment.limitMaxUpload);

  constructor(component, options, data) {
    super(component, options, data);
    this.component = component;
    this.options = options;
    this.data = data;
    this.editor = options.editor;
  }

  static schema() {
    return Base.schema({
      type: 'upload',
    });
  }

  /**
   * Render returns an html string of the fully rendered component.
   *
   * @param children - If this class is extendended, the sub string is passed as children.
   * @returns {string}
   */
  render(children) {
    let content = '';
    const fileList = Array.isArray(this.component.upload_content) ? this.component.upload_content: false;

    if (fileList) {
      fileList.forEach((file, index) => {
        file = Object.keys(file).reduce((prev, current) => ({ ...prev, [current.toLocaleUpperCase()]: file[current]}), {});
        file.STATUSENVIO = String(file.STATUSENVIO);
        content += this.createUploadItem(file, index);
      });
    } else if (this.editor) {
      content += this.createUploadItem({
        STATUSENVIO: null,
        MOTIVORECUSA: null,
        OBRIGATORIO: 0,
        DESCRICAODOCUMENTO: 'Descrição do arquivo',
        CODTIPODOCUMENTO: '0',
        PATHARQUIVO: null,
        CHAVERM: null
      }, 0);
    }



    return super.render(`
      <div>
        ${content}
      </div>
    `);
  }

  mapObjectByProperties(object: any = {}, properties: Array<string> = []) {
    const getSelectedProperties = (selectedProperties, property) => ({ ...selectedProperties, [property.toUpperCase()]: object[property] });
    return properties.reduce(getSelectedProperties, {});
  }

  /**
   * Cria um item com um input para dar upload
   * @param file // informações sobre o arquivo pedido
   * @param index // indice do arquivo pedido
   */
  createUploadItem(file, index) {
    const OBRIGATORIO = String(file.OBRIGATORIO);
    const title = `
    ${this.getStatus(file, index)}
    <span class="ps-comp-upload-description">
      ${file.DESCRICAODOCUMENTO}
      ${OBRIGATORIO == '1' ? ' *' : '' }
    </span>
    `;
    const inputAttr: any = {
      id: `${this.component.key}-input-id-${index}`,
      class: 'hidden-file-item',
      type: 'file',
      required : OBRIGATORIO == '1' ? true : false,
    }
    if (this.component.upload_multiple_files) {
      inputAttr.multiple = true;
    }

    const input = this.renderTemplate('input', {
      input: {
        type: 'input',
        ref: `${this.component.key}-input-${index}`,
        attr: inputAttr
      }
    })


    const item = `
    <div style="margin: 0 0 20px 0" >
      <div class="ps-comp-upload-container-column" ref="${this.component.key}-file-item-${index}">
        <div class="ps-comp-upload-container-row">
          <div class="ps-comp-upload-container-flex ps-comp-upload-container-flex-order-1">
            ${title}
            ${input}
          </div>
          <div class="ps-comp-upload-container-flex ps-comp-upload-container-flex-order-3 ps-comp-upload-container-flex-mobile">
            ${this.createSendButton(file.STATUSENVIO, index)}
          </div>
        </div>
        ${this.createSelectedFilesList(index)}
      </div>
      <div class="ps-comp-upload-container-flex ps-comp-upload-container-flex-hidden-mobile">
        ${this.setStatusName(file, index)}
      </div>
      <div class="ps-comp-upload-flex-hidden-desktop ps-comp-upload-container-flex ps-comp-upload-container-flex-order-2">
        ${this.setStatusName(file, index)}
      </div>
    </div>
    `;
    return item;
  }

  /**
   * Gera um icone de status para o item do upload
   * @param file // informações sobre o arquivo pedido
   * @param index // index do elemento
   * @field 1 EM ANALISE
   * @field 2 RECUSADO
   * @field 3 APROVADO
   * @field null Padrão
   */
  getStatus(file, index) {
    let icon = '';
    switch (file.STATUSENVIO) {
      case '1': // em analise
        icon += icon += `<i
          id="ps-comp-${this.component.key}-upload-icon-${index}"
          class="ps-comp-upload-icon-type-in-analysis"
          title="Arquivo em análise">
          ${this.setIconeImageAccordingToStatus(file.STATUSENVIO)}
        </i>`;
        break;
        case '2': // Recusado
        icon += icon += `
        <i
          id="ps-comp-${this.component.key}-upload-icon-${index}"
          class="ps-comp-upload-icon-type-refused"
          title="Arquivo recusado">
          ${this.setIconeImageAccordingToStatus(file.STATUSENVIO)}
        </i>
        `;
        break;
      case '3': // APROVADO
        icon += icon += `<i
          id="ps-comp-${this.component.key}-upload-icon-${index}"
          class="ps-comp-upload-icon-type-approved"
          title="Arquivo aprovado">
          ${this.setIconeImageAccordingToStatus(file.STATUSENVIO)}
        </i>`;
        break;
      default:
        icon += `<i
          id="ps-comp-${this.component.key}-upload-icon-${index}"
          class="ps-comp-upload-icon-type-default"
          title="Nenhum arquivo selecionado">
          ${this.setIconeImageAccordingToStatus(file.STATUSENVIO)}
        </i>`;
        break;
    }

    let status = '';
    status += `${icon}`;

    return status;
  }

  /**
   * After the html string has been mounted into the dom, the dom element is returned here. Use refs to find specific
   * elements to attach functionality to.
   *
   * @param element
   * @returns {Promise}
   */

  attach(element) {
    const fileList = Array.isArray(this.component.upload_content) ? this.component.upload_content: false;
    this.loadUploadElementRefs(element);

    if (fileList) {
      fileList.forEach((file, index) => {
        const uploadButton = this.refs[`${this.component.key}-uploadBtn-${index}`][0];
        const selectedFilesList = this.refs[`${this.component.key}-selectedFilesList-${index}`][0];
        const input = this.refs[`${this.component.key}-input-${index}`][0];
        this.addEventListener(input, 'change', () => this.fileInputValueChange(input, selectedFilesList, file, index));
        this.addEventListener(uploadButton, 'click', () => this.triggerFileInput(input));
        this.inputs.push({input, files: []});
      });
    }

    return super.attach(element);
  }


  /**
   * carrega as referencias especificas do elemento upload no array global de referencias do DOM
   * @param index
   */

  loadUploadElementRefs(element) {
    const fileList = Array.isArray(this.component.upload_content) ? this.component.upload_content: false;
    const refs = [];

    if (fileList) {
      fileList.forEach((file, index) => {
        refs[`${this.component.key}-input-${index}`] = 'multiple';
        refs[`${this.component.key}-uploadBtn-${index}`] = 'multiple';
        refs[`${this.component.key}-selectedFilesList-${index}`] = 'multiple';
      });
    }

    this.loadRefs(element, refs);
  }

  fileInputValueChange(input, selectedfileList, file, inputIndex) {
    this.concatFilesArray(inputIndex, input);
    this.updateTotalSize();
    if(this.checkExceededLimit()){
      this.removeLastFileAdded(inputIndex);
      this.showAlertLimitExeceeded();
    } else {
      this.createSelectedFilesChips(selectedfileList, this.inputs[inputIndex].files, inputIndex);
      this.changesColorOfStandardIcon(false, inputIndex);
      // this.showOrHideTheRemoveButton(true, inputIndex);
      if (file.STATUSENVIO === '2') {
        this.pickUpTheIconeElementAccordingToYourIndex(inputIndex).children[0].outerHTML = this.setIconeImageAccordingToStatus();
        this.takeTheNameElementOfTheRefusedStatus(inputIndex).style.display = 'none';
      }
    }
    this.updateTotalSize();
    this.updateValue();
  }

  concatFilesArray(inputIndex, input) {
    if (this.component.upload_multiple_files) {
      if (this.inputs[inputIndex].files.length === 0) {
        this.inputs[inputIndex].files = Array.from(input.files);
      } else {
        this.inputs[inputIndex].files = this.inputs[inputIndex].files.concat(Array.from(input.files));
      }
    } else {
      this.inputs[inputIndex].files = Array.from(input.files);
    }
    input.value = '';
  }

  createSelectedFilesChips(selectedfileList, files, inputIndex) {
    selectedfileList.innerHTML = '';
    for (let index = 0; index < files.length; index++) {
      const file = files[index];

      const chip = document.createElement('span');
      chip.setAttribute('class', 'ps-file-chip');
      chip.setAttribute('id', `ps-file-chip-${inputIndex}-${index}`);
      chip.innerText=`${file.name}  `
      const button = this.createButtonElement(index, inputIndex);
      this.addButtonEvent(button, index, inputIndex, selectedfileList);
      chip.appendChild(button);
      selectedfileList.appendChild(chip);
      if (file.error) {
        const error_message = document.createElement('div');
        error_message.innerText = file.error
        error_message.setAttribute('class', 'ps-error-text file-error');
        error_message.id = `error-${inputIndex}-${index}`;
        selectedfileList.appendChild(error_message);
      }
    }
  }

  createButtonElement(index, inputIndex) {
      const button = document.createElement('button');
      button.setAttribute('title', 'Excluir arquivo');
      button.setAttribute('id', `id="ps-comp-upload-button-remove-${index}"`);
      button.setAttribute('class', `btn ps-comp-upload-button`);
      const icon = document.createElement('i');
      icon.setAttribute('class', `material-icons`);
      icon.setAttribute('style', 'font-size: 20px;');
      icon.innerHTML = 'clear'
      button.appendChild(icon);
      return button
  }

  addButtonEvent(button, index, inputIndex, selectedfileList) {
    button.addEventListener('click', () => this.removeFileItem(index, inputIndex, selectedfileList))
  }

  removeFileItem(index, inputIndex, selectedfileList) {
    this.inputs[inputIndex].files.splice(index, 1);
    if (this.inputs[inputIndex].files.length === 0) {
      this.changesColorOfStandardIcon(true, inputIndex);
    }
    this.createSelectedFilesChips(selectedfileList, this.inputs[inputIndex].files, inputIndex);
    this.updateTotalSize();
    this.updateValue();
  }

  /**
   * ativa a função de clique de um input escondido que refere-se ao documento pedido
   * @param input // elemento input referente a linha que está o documento
   */

  triggerFileInput(input) {
    input.click();
  }

  /**
   * @param true Se o botão de excluir o arquivo foi acionado
   * @param false Se o botão de excluir o arquivo foi não foi acionado
   */
  private changesColorOfStandardIcon(deleteButtonWasPressed, index) {
    if (deleteButtonWasPressed) {
      this.pickUpTheIconeElementAccordingToYourIndex(index).classList.remove('ps-comp-upload-icon-type-default-on');
      this.pickUpTheIconeElementAccordingToYourIndex(index).attributes[0].value = 'Nenhum arquivo selecionado';
    } else {
      this.pickUpTheIconeElementAccordingToYourIndex(index).classList.add('ps-comp-upload-icon-type-default-on');
      this.pickUpTheIconeElementAccordingToYourIndex(index).attributes[0].value = 'Arquivo selecionado';
    }
  }

  private pickUpTheIconeElementAccordingToYourIndex(elementIndex) {
    return document.getElementById(`ps-comp-${this.component.key}-upload-icon-` + elementIndex);
  }

  private takeTheNameElementOfTheRefusedStatus(elementIndex) {
    return document.getElementById(`ps-comp-${this.component.key}-upload-status-name-refused-` + elementIndex);
  }

  private setStatusName(file, index) {

    switch (file.STATUSENVIO) {
      case '1':
        return `<span class="ps-comp-upload-status-name">Em análise</span>`;
      case '2':
        return `
          <span  id="ps-comp-${this.component.key}-upload-status-name-refused-${index}" class="ps-comp-upload-status-name-refused">
            Recusado: ${file.MOTIVORECUSA ?? ''}
          </span>
        `;
      case '3':
        return `<span class="ps-comp-upload-status-name-approved">Aprovado</span>`;
      default:
        return '';
    }
  }

  private setIconeImageAccordingToStatus(fileStatus = null) {
    switch (fileStatus) {
      case '2':
        return `<img style="margin-left: 1px;" src="../../../../assets/images/icons/refused.svg">`;
      case '3':
        return `<img src="../../../../assets/images/icons/approved.svg">`;
      default:
        return `<img src="../../../../assets/images/icons/clip.svg">`;
    }
  }


  private createSendButton(fileStatus, index) {
    if (fileStatus === null || (fileStatus === '2' && this.component.block_attaching_reject_files == 0) || fileStatus === 'undefined' || fileStatus === undefined) {
      return `
      <button
        title="Adicionar arquivo"
        id="ps-comp-upload-button-send-${index}"
        class="btn ps-comp-upload-button"
        ref="${this.component.key}-uploadBtn-${index}">
          <span class="ps-comp-upload-description" >Anexar <i class="material-icons">cloud_upload</i></span>
      </button>`;
    } else {
      return `
      <button
        title="Adicionar arquivo"
        id="ps-comp-upload-button-send-${index}"
        class="btn ps-comp-upload-button hidden-file-item"
        ref="${this.component.key}-uploadBtn-${index}">
        <span class="ps-comp-upload-description" >Anexar <i class="material-icons">cloud_upload</i></span>
      </button>`;
    }
  }

  private createSelectedFilesList(index) {
    return `<div id="${this.component.key}-selectedFilesList-${index}" class="ps-comp-upload-container-chips" style="margin: 0px 30px" ref="${this.component.key}-selectedFilesList-${index}"></div>`;
  }

  private removeLastFileAdded(inputIndex) {
    this.inputs[inputIndex].files.pop();
  }

  private updateTotalSize() {
    this.totalSize = this.inputs ? this.calculateTotalSize() : 0;
  }

  private calculateTotalSize():number {
    let totalSize = 0;
    this.inputs.forEach((file) => {
      totalSize = file.files.reduce((acc:number,archive:any) => acc + archive.size,totalSize);
    });

    return totalSize;
  }

  private convertMBToByte(value: number): number {
    return value * 1048576;
  }

  private checkExceededLimit():boolean {
    return (this.totalSize > this.limitSize) ? true : false;
  }

  private showAlertLimitExeceeded() {
    const message = `O tamanho total dos arquivos não pode ultrapassar ${environment.limitMaxUpload} megabytes.`;
    (window as any).formFunctions.showNotificationComponent(message, 'Atenção', 'alert', 10000);
  }

  /**
  * Get the value of the component from the dom elements.
  *
  * @returns {Array}
  */

   getValue() {
    const value = [];
    let hasFiles = false;
    let acceptingFile = true;
    this.inputs.forEach((input, index) => {
      const fileItem = this.component.upload_content;
      fileItem[index] = Object.keys(fileItem[index]).reduce((prev, current) => ({ ...prev, [current.toLocaleUpperCase()]: fileItem[index][current]}), {});

      if (input.files.length > 0) {
        hasFiles = true;
      }

      if (fileItem[index].STATUSENVIO !== "1" && fileItem[index].STATUSENVIO !== "3") {
        acceptingFile = false;
      }

      value.push(
        {
          'CODIGO': fileItem[index].CODTIPODOCUMENTO,
          'title': fileItem[index].DESCRICAODOCUMENTO,
          'STATUSENVIO': fileItem[index].STATUSENVIO === 'undefined' || fileItem[index].STATUSENVIO === undefined  ? null : fileItem[index].STATUSENVIO,
          'PATHARQUIVO': fileItem[index].PATHARQUIVO === 'undefined' || fileItem[index].PATHARQUIVO === undefined ? null : fileItem[index].PATHARQUIVO,
          'CHAVERM': fileItem[index].CHAVERM === 'undefined' || fileItem[index].CHAVERM === undefined ? null : fileItem[index].CHAVERM,
          'files': input.files,
          'value': null
        }
      )

    });
    if (hasFiles || acceptingFile) {
      return value;
    }
    return null;
  }


  /**
   * Set the value of the component into the dom elements.
   * Não tem como setar arquivo em input de arquivo, por motivos de segurança do navegador,
   * então o valor vai ficar em um item do this.component.fileList em item.url
   * @param value
   * @returns {Array}
   */
  setValue(values) {
    const fileList = Array.isArray(this.component.upload_content) ? this.component.upload_content: false;
    if (fileList) {
      if (values !== null) {
        if (Array.isArray(values) && Array.isArray(fileList)) {
          values.forEach(value => {
            fileList.forEach((file, i) => {
              if (file.CODTIPODOCUMENTO === value.CODIGO) {
                file.url = value.value
              }
            });
          });
        }
      }
      this.updateValue();
    }
  }

}


export function registryUploadComponent() {
  Components.addComponent('upload', Upload);
}



